var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"examModel",on:{"mousemove":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"mask",on:{"mousemove":function($event){$event.preventDefault();}}}),_c('div',{staticClass:"content1"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }